import React, { useEffect, useState, useCallback, useRef } from 'react'
import styled from 'styled-components'
import { ExpandCircleDownOutlined } from '@mui/icons-material'

import Card from 'components/Card'
import Tooltip from 'components/Tooltip'

const ANIMATION_TIME = 400

type Props = {
  onClickCaret?: () => void | undefined
  title: string
  children: React.ReactNode
  className?: string
  collapsedByDefault?: boolean
}

const CollapsibleCard = ({ collapsedByDefault = false, onClickCaret, title, children, className = '' }: Props) => {
  const ref = useRef(null)

  const [isCollapsed, setIsCollapsed] = useState(collapsedByDefault)
  const [isCaretCollapsed, setIsCaretCollapsed] = useState(collapsedByDefault)

  useEffect(() => {
    if (ref.current && isCollapsed) {
      $(ref.current).hide()
    }
  }, [isCollapsed])

  const onClick = useCallback(() => {
    if (ref.current && !isCollapsed) {
      $(ref.current).slideUp(ANIMATION_TIME)
    } else if (ref.current && isCollapsed) {
      $(ref.current).slideDown(ANIMATION_TIME)
    }

    setIsCaretCollapsed(!isCaretCollapsed)

    setTimeout(() => {
      setIsCollapsed(!isCollapsed)
    }, ANIMATION_TIME)

    if (onClickCaret) {
      onClickCaret()
    }
  }, [isCollapsed, isCaretCollapsed, onClickCaret])

  return (
    <Card
      title={title}
      className={className}
      onClickTitleAreaCallback={onClick}
      titleAreaLeft={
        <Tooltip title={isCaretCollapsed ? 'Click to expand' : 'Click to minimize'} placement="top">
          <S.CaretIcon
            aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} content for ${title}`}
            isCaretCollapsed={isCaretCollapsed}
          />
        </Tooltip>
      }
      titleAreaStyle="cursor: pointer;"
    >
      <div ref={ref}>
        {children}
      </div>
    </Card>
  )
}

export default CollapsibleCard

const S = {
  CaretIcon: styled(ExpandCircleDownOutlined).withConfig({
    shouldForwardProp: (prop) => !['isCaretCollapsed'].includes(prop)
  }) <{ isCaretCollapsed: boolean }>`
    margin-right: 10px;
    transform: ${({ isCaretCollapsed }) => (isCaretCollapsed ? 'rotate(-90deg)' : 'rotate(0deg)')};
  `
}
